import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class LayerSources extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'LayerSources'
  // Define default properties here
  static instanceDefaults () {
    return {
      name: '',
    }
  }
}
const servicePath = 'layer-sources'
const servicePlugin = makeServicePlugin({
  Model: LayerSources,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
